import React, { useState } from 'react';
import { FiArrowUpRight, FiGlobe, FiCode } from 'react-icons/fi';
import { SiWindows, SiApple } from 'react-icons/si';
import './SoftwareProducts.css';
import ProductCarousel, { CarouselScreen } from './ProductCarousel';

import gridMP3Img1 from '../../media/gridMP3-1.png';
import gridMP3Img2 from '../../media/gridMP3-2.png';
import gridMP3Img3 from '../../media/gridMP3-3.png';
import gridMP3Img4 from '../../media/gridMP3-4.png';
import gridMP3Img5 from '../../media/gridMP3-5.png';

import civicsImg1 from '../../media/civics-1.png';
import civicsImg2 from '../../media/civics-2.png';
import civicsImg3 from '../../media/civics-3.png';
import civicsImg4 from '../../media/civics-4.png';
import civicsImg5 from '../../media/civics-5.png';
import civicsImg6 from '../../media/civics-6.png';
import civicsImg7 from '../../media/civics-7.png';
import civicsImg8 from '../../media/civics-8.png';

import homeCookImg1 from '../../media/home-cook-1.png';
import homeCookImg2 from '../../media/home-cook-2.png';
import homeCookImg3 from '../../media/home-cook-3.png';
import homeCookImg4 from '../../media/home-cook-4.png';
import homeCookImg5 from '../../media/home-cook-5.png';
import homeCookImg6 from '../../media/home-cook-6.png';
import homeCookImg7 from '../../media/home-cook-7.png';
import homeCookImg8 from '../../media/home-cook-8.png';
import homeCookImg9 from '../../media/home-cook-9.png';
import homeCookImg10 from '../../media/home-cook-10.png';
import homeCookImg11 from '../../media/home-cook-11.png';

import footyImg1 from '../../media/footy-1.png';
import footyImg2 from '../../media/footy-2.png';
import footyImg3 from '../../media/footy-3.png';
import footyImg4 from '../../media/footy-4.png';
import footyImg5 from '../../media/footy-5.png';
import footyImg6 from '../../media/footy-6.png';
import footyImg7 from '../../media/footy-7.png';
import footyImg8 from '../../media/footy-8.png';

const PRODUCTS = [
  {
    icon: (
      <div style={{ display: 'flex', gap: '8px' }}>
        <div className="software__card-icon"><SiWindows size={22} /></div>
        <div className="software__card-icon"><SiApple size={22} /></div>
      </div>
    ),
    tag: 'Windows, Mac & iPhone',
    name: 'Party Request',
    desc: 'A music-first event app for DJs and hosts to gather song requests, understand the vibe, and build a stronger connection with their audience.',
    status: 'In Review / Beta',
    anchor: 'partyrequest',
    link: 'https://party-request.com',
    windowsStoreLink: 'https://party-request.com',
    macStoreLink: 'https://party-request.com',
    screens: [] as CarouselScreen[]
  },
  {
    icon: <SiApple size={22} />,
    tag: 'iPhone App',
    name: 'Civics Tutor 2025',
    desc: 'Study and pass the US Citizenship civics exam with a varierty of different study modes designed to help you learn the 128 official questions and answers.',
    status: 'Live',
    anchor: 'civicstutor',
    link: 'https://apps.apple.com/us/app/civics-tutor/id6772397800',
    screens: [
      { image: civicsImg1, description: 'Welcome screen with study options' },
      { image: civicsImg2, description: 'Quiz mode' },
      { image: civicsImg3, description: 'Study all questions' },
      { image: civicsImg4, description: 'Study all questions including state specific' },
      { image: civicsImg5, description: 'Multiple choice practice' },
      { image: civicsImg6, description: 'Multiple choice practice including multiple answer options' },
      { image: civicsImg7, description: 'Achievement system and rewards' },
      { image: civicsImg8, description: 'Dark mode interface' },
    ] as CarouselScreen[]
  },
  {
    icon: <FiGlobe size={22} />,
    tag: 'Web Application',
    name: 'Footy Creator',
    desc: 'A specialized content portal for online creators built around any soccer team in the world — stats, media tools, and community features in one place.',
    status: 'Live',
    anchor: 'footycreator',
    link: 'https://www.footycreator.com/',
    screens: [
      { image: footyImg1, description: 'App selection' },
      { image: footyImg2, description: 'Pick a match to see live progress or final results' },
      { image: footyImg3, description: 'Match center and live updates' },
      { image: footyImg4, description: 'Create and manage formations' },
      { image: footyImg5, description: 'Rate the players' },
      { image: footyImg6, description: 'Predict results with friends for upcoming games' },
      { image: footyImg7, description: 'Create different channels' },
      { image: footyImg8, description: 'Language support' },
    ] as CarouselScreen[]

  },  
  {
    icon: (
      <div style={{ display: 'flex', gap: '8px' }}>
        <div className="software__card-icon"><SiWindows size={22} /></div>
        <div className="software__card-icon"><SiApple size={22} /></div>
      </div>
    ),
    tag: 'Windows & Mac',
    name: 'GridMP3',
    desc: 'A powerful MP3 tag editor built for DJs — bulk-edit metadata, organize large libraries, and keep your collection clean and cue-ready.',
    status: 'Coming Soon',
    anchor: 'gridmp3',
    windowsStoreLink: 'https://apps.microsoft.com/apps',
    macStoreLink: 'https://apps.apple.com/us/mac/discover',
    screens: [
      { image: gridMP3Img1, description: 'Browse and edit inline for any tag' },
      { image: gridMP3Img2, description: 'Advanced configuration options' },
      { image: gridMP3Img3, description: 'Bulk update text in tags using find and replace tools' },
      { image: gridMP3Img4, description: 'Built in audio preview and playback with key and BPM detection' },
      { image: gridMP3Img5, description: 'Filter down to the files that matter (Minimized audio player shown)' },
    ] as CarouselScreen[]
  },
  {
    icon: <SiApple size={22} />,
    tag: 'iPhone App',
    name: 'Home Cookbook',
    desc: 'A recipe manager and meal planner — save recipes, create shopping lists, and plan meals with an intuitive interface. Share with the faimily and friends!',
    status: 'Coming Soon',
    anchor: 'homecookbook',
    link: 'https://apps.apple.com/us/iphone/today',
    screens: [
      { image: homeCookImg1, description: 'Create/login with an account or use in local mode' },
      { image: homeCookImg2, description: 'App main dashboard' },
      { image: homeCookImg3, description: 'Easy listing of all your recipes' },
      { image: homeCookImg4, description: 'Detailed recipe view with ingredients' },
      { image: homeCookImg5, description: 'Cooking view of selected recipe' },
      { image: homeCookImg6, description: 'Grocery list for your recipes and plans' },
      { image: homeCookImg7, description: 'Create meal plans and add extra items' },
      { image: homeCookImg8, description: 'View a meal plan to add to grocery list' },
      { image: homeCookImg9, description: 'Dark mode' },
      { image: homeCookImg10, description: 'Profile with cloud sync option' },
      { image: homeCookImg11, description: 'Store common ingredients' },
    ] as CarouselScreen[]
  },

  {
    icon: (
      <div style={{ display: 'flex', gap: '8px' }}>
        <div className="software__card-icon"><SiWindows size={22} /></div>
        <div className="software__card-icon"><SiApple size={22} /></div>
      </div>
    ),
    tag: 'Windows, Mac & iPhone',
    name: 'Lock-n-Key',
    desc: 'A password manager for KeePass databases — securely store, organize, and access your credentials across Windows, Mac, and iPhone.',
    status: 'Coming Soon',
    anchor: 'locknkey',
    windowsStoreLink: '#',
    macStoreLink: '#',
    screens: [] as CarouselScreen[]
  },
];

const SOFTWARE_SERVICES = [
  {
    icon: <FiCode size={22} />,
    tag: 'AI Platform',
    name: 'token-kit',
    desc: 'An AI platform that lets small app developers integrate LLMs into their products — powered by tokens purchased directly by the end consumer. No API keys, no billing headaches.',
    status: 'Live Beta',
    anchor: 'tokenkit',
    link: 'https://www.token-kit.com',
    screens: [] as CarouselScreen[]
  },
  {
    icon: <FiCode size={22} />,
    tag: 'NPM Package',
    name: 'token-kit (SDK)',
    desc: 'Open-source SDK for integrating token-kit into your JavaScript/TypeScript applications. Build AI-powered features with simple, developer-friendly APIs.',
    status: 'Beta Release',
    anchor: 'tokenkit-sdk',
    link: 'https://www.npmjs.com/package/@codetunezstudios/token-kit',
    screens: [] as CarouselScreen[]
  },
  {
    icon: <FiGlobe size={22} />,
    tag: 'AI',
    name: 'AI Tokens',
    desc: 'A place to buy and manage tokens for apps powered by token-kit. Purchase tokens directly and use them across any app in the token-kit ecosystem. No subscriptions',
    status: 'Live Beta',
    anchor: 'aitokens',
    link: 'https://ai-tokens.me',
    screens: [] as CarouselScreen[]
  }
];

const STATUS_COLORS: Record<string, string> = {
  'Live': '#00d97e',
  'Publishing Soon': '#6c63ff',
  'In Development': '#f5a623',
  'In Beta': '#f5a623',
  'In Review': '#f5a623',
  'In Review / Beta': '#f5a623',
  'Beta Release': '#00d97e',
  'Live Beta': '#00d97e',
};

const SoftwareProducts: React.FC = () => {
  const [activeCarousel, setActiveCarousel] = useState<number | null>(null);
  const [activeSource, setActiveSource] = useState<'products' | 'services'>('products');

  const handleLearnMore = (index: number, product: typeof PRODUCTS[0], source: 'products' | 'services') => {
    if (product.screens && product.screens.length > 0) {
      setActiveCarousel(index);
      setActiveSource(source);
    } else if (product.link) {
      window.open(product.link, '_blank');
    }
  };

  const renderProductCard = (product: typeof PRODUCTS[0], i: number, source: 'products' | 'services') => (
    <div className="software__card" key={i} id={product.anchor}>
      <div className="software__card-top">
        {(product.anchor === 'gridmp3' || product.anchor === 'partyrequest' || product.anchor === 'locknkey') ? (
          <div style={{ display: 'flex', gap: '8px' }}>
            <a href={product.windowsStoreLink || '#'} target="_blank" rel="noopener noreferrer" className="software__card-icon-link">
              <div className="software__card-icon"><SiWindows size={22} /></div>
            </a>
            <a href={product.macStoreLink || '#'} target="_blank" rel="noopener noreferrer" className="software__card-icon-link">
              <div className="software__card-icon"><SiApple size={22} /></div>
            </a>
          </div>
        ) : (
          <a href={product.link || '#'} target="_blank" rel="noopener noreferrer" className="software__card-icon-link">
            <div className="software__card-icon">{product.icon}</div>
          </a>
        )}
        <span
          className="software__card-status"
          style={{ color: STATUS_COLORS[product.status] }}
        >
          <span
            className="software__status-dot"
            style={{ background: STATUS_COLORS[product.status] }}
          />
          {product.status}
        </span>
      </div>
      <p className="software__card-tag">{product.tag}</p>
      <h3 className="software__card-name">{product.name}</h3>
      <p className="software__card-desc">{product.desc}</p>
      {(product.screens.length > 0 || product.link) && (
        <button
          className="software__card-link"
          onClick={() => handleLearnMore(i, product, source)}
        >
          Learn More <FiArrowUpRight />
        </button>
      )}
    </div>
  );

  const activeProducts = activeSource === 'products' ? PRODUCTS : SOFTWARE_SERVICES;

  return (
    <section id="software" className="software">
      <div className="container">
        <div className="software__header">
          <p className="section-label">Software Products</p>
          <h2 className="section-title">
            Apps &amp; Experiences <span className="gradient-text">We Ship</span>
          </h2>
          <p className="section-subtitle">
            From mobile apps to desktop tools and web experiences, we build software that's
            thoughtfully crafted and production-ready.
          </p>
        </div>

        <div className="software__grid">
          {PRODUCTS.map((product, i) => renderProductCard(product, i, 'products'))}
        </div>

        <div className="software__subsection-header">
          <h3 className="software__subsection-title">Software Services</h3>
          <p className="software__subsection-desc">
            Developer tools and platforms for building AI-powered applications with ease.
          </p>
        </div>

        <div className="software__grid">
          {SOFTWARE_SERVICES.map((product, i) => renderProductCard(product, i, 'services'))}
        </div>

      </div>

      {activeCarousel !== null && activeProducts[activeCarousel]?.screens && (
        <ProductCarousel
          productName={activeProducts[activeCarousel].name}
          screens={activeProducts[activeCarousel].screens!}
          onClose={() => setActiveCarousel(null)}
        />
      )}
    </section>
  );
};

export default SoftwareProducts;
